import { useState, useEffect, useRef } from "react";
import { searchTypes } from "../../enum/searchTypes";
import useTitanApp from "../../hooks/useTitanApp";

const SearchableMadicineDropdown = ({
  label,
  id,
  selectedVal,
  handleChange,
  searchType,
  options,
}) => {
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [searchOptions, setSearchOptions] = useState(options);
  const inputRef = useRef(null);

  const toggleDropdown = (e) => {
    setIsOpen(e && e.target === inputRef.current);
  };

  useEffect(() => {
    document.addEventListener("click", toggleDropdown);
    return () => document.removeEventListener("click", toggleDropdown);
  }, []);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    setIsOpen(true);
    
    if (value.length > 0) {
      const filteredOptions = options.filter((option) =>
        option.drugName?.toLowerCase().includes(value.toLowerCase())
      );
      setSearchOptions(filteredOptions);
    } else {
      setSearchOptions([]);
    }
  };

  const selectOption = (option) => {
    setQuery(option?.drugName || "");
    handleChange(option); // Call API here via handleMedicineName
    setIsOpen(false);
  };

  return (
    <div className="search_dropdown searchable_dropdown_main_wrapper">
      <div className="control">
        <div className="selected-value">
          <input
            ref={inputRef}
            type="text"
            value={query}
            name="searchTerm"
            onChange={handleInputChange}
            placeholder="Search..."
          />
        </div>
      </div>

      {isOpen && searchOptions?.length > 0 && (
        <div className="options open">
          {searchOptions.map((option, index) => (
            <div
              onClick={() => selectOption(option)}
              className={`option ${
                option?.drugName === selectedVal ? "selected" : ""
              }`}
              key={`${id}-${index}`}
            >
              {option.drugName}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchableMadicineDropdown;
